import React from "react";
import { IconFile } from "@tabler/icons-react";
import clsx from "clsx";
import { LoadingState, OverviewProps } from "./SearchTable";
import { Material2050SearchOUT } from "api-client";

interface EPDRowProps {
  epd: Material2050SearchOUT;
  showOverview: OverviewProps;
  setOpenOverview: (item: Material2050SearchOUT) => void;
  handleSelectEPD: (epd_id: string) => void;
  loadingEPDSelect: LoadingState;
}

const EPDRow = ({ epd, ...props }: EPDRowProps) => {
  return (
    <li
      className={clsx(
        "flex relative border-b border-gray-300 hover:bg-indigo-50 group/listItem overflow-hidden",
        {
          "h-16": !props.showOverview.state,
          "bg-indigo-50 ": props.showOverview.epd?.id === epd.id,
          "shadow-[inset_0_0_0_1px] shadow-indigo-600":
            props.showOverview.epd?.id === epd.id,
        }
      )}
      onClick={() => props.setOpenOverview(epd)}
    >
      <div className="flex pl-3 py-2">
        <IconFile
          stroke={3}
          className="bg-pink-300 text-pink-900 p-1 rounded-full mr-[10px] min-w-[24px]"
        />
        <div>
          <p className="text-sm mb-1 text-indigo-800 font-normal">
            {epd.company}
          </p>
          <p className="text-base font-semibold group-hover/listItem:text-indigo-900 transition">
            {epd.name}
          </p>
        </div>
      </div>
    </li>
  );
};

export default EPDRow;
